module.exports = __webpack_public_path__ + "media/images/shared/icon_lang-0749c9a4c2ba435f6a18c9ae84d3d1ed.svg";